import React, { FC } from "react";
import { Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface DriverLinkCellProps {
  driverName: string;
}

const DriverLinkCell: FC<DriverLinkCellProps> = ({ driverName }) => {
  const navigate = useNavigate();

  const handleDriverClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (driverName && driverName !== "-") {
      navigate(
        `/dashboard/users?search=${encodeURIComponent(driverName)}&page=1`
      );
    }
  };

  if (!driverName || driverName === "-") {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Link
      component="button"
      variant="body2"
      onClick={handleDriverClick}
      sx={{
        textDecoration: "none",
        color: "#1D1F2B",
        cursor: "pointer",
        "&:hover": {
          textDecoration: "underline",
          color: "#1565c0"
        },
        background: "none",
        border: "none",
        padding: 0,
        font: "inherit",
        textAlign: "left",
        fontWeight: 500,
        fontSize: "14px"
      }}
    >
      {driverName}
    </Link>
  );
};

export default DriverLinkCell;
